<template>
  <div
    class="import-preset"
    @keydown.stop.enter="apply(inputValue)"
  >
    <GwInput
      :placeholder="$t('common.import_setting')"
      type="text"
      autofocus
      :getErrors="() => (inputError ? [$t(`messages.preset_solfigr_setting_error`)] : [])"
      :value="inputValue"
      @input="(_e, value) => (inputValue = value)"
      @keydown:enter="apply(inputValue)"
    />
    <portal to="dialog_actions">
      <v-btn
        data-tst="btn_apply_filter"
        color="primary"
        class="ml-2"
        :loading="loading"
        @click="apply"
      >
        {{ $t('btn.confirm') }}
      </v-btn>
    </portal>
  </div>
</template>

<script>
import { getLegalPositions } from '@/helpers/constants'
import { getSolfigrFields } from '@/store/solfigr/solfigr_helpers'
import GwInput from '@/components/lib/GwInput'

export default {
  name: 'ImportSolfigrTree',
  components: { GwInput },
  data() {
    return {
      inputValue: '',
      inputError: false,
      loading: false,
    }
  },
  methods: {
    getPartialValidateTreeSettings(preset) {
      // preset.players[0].display_position = 'XXX'
      // preset.players[0].range[1] = 333
      // preset.pot = 111111
      // - flop_stackPotCheck
      // preset.players[0].stack = 999
      // preset.pot = 2

      let error = false

      const positions = [...getLegalPositions(), 'IP', 'OOP']
      const playerOOP = preset.players?.[0] || {}
      const playerIP = preset.players?.[1] || {}
      error =
        !positions.includes(playerOOP.display_position) ||
        !positions.includes(playerIP.display_position)
          ? 'invalid_position'
          : false
      if (error) return error

      error = [playerOOP.range, playerIP.range].some(range => range.some(v => v < 0 || v > 1))
        ? 'invalid_range'
        : false
      if (error) return error

      const fields = getSolfigrFields()
      const { pot } = preset
      const { stack } = playerOOP
      error = [
        [fields.pot, pot],
        [fields.stack, stack],
      ].some(arr => arr[0].min > arr[1] || arr[0].max < arr[1])
        ? 'minmax_stackpot'
        : !fields.pot.flop_stackPotCheck({ stack, pot })
          ? 'invalid_stackpot'
          : false
      if (error) return error

      return null
    },
    validateTreeSettings(inputVal) {
      let error = null
      let preset = null
      try {
        preset = JSON.parse(inputVal)
      } catch (err) {
        error = 'invalid_json'
      }

      // error = error || this.getPartialValidateTreeSettings(preset)
      return { preset, error }
    },
    async apply() {
      this.inputError = false

      const { preset, error } = this.validateTreeSettings(this.inputValue)
      // console.log(error)
      if (error) {
        this.inputError = error
        return
      }

      this.loading = true
      // only changes that include tournament_data need to go throu v4
      const result = await this.$store.dispatch('api_call', {
        endpoint: 'custom-solutions/custom-trees/saved-trees/',
        apiVersion: 'v4',
        method: 'POST',
        data: preset,
        action: 'slfrm_handleApiTreeImport',
      })
      this.loading = false

      if (result.status !== 201 || result.status !== 200) {
        this.inputError = 'api_error'
      }
    },
  },
}
</script>

<style lang="scss">
.import-preset {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 32rem;
  max-width: 100%;
}
</style>
